"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _ActivitySelectionPopup = _interopRequireDefault(require("../../appRenovation/component/components/ActivitySelectionPopup.vue"));
var _customPage = require("@/api/customPage");
var _ossUpload = require("@/utils/ossUpload");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    ActivitySelectionPopup: _ActivitySelectionPopup.default
  },
  data: function data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '长期有效',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            end.setTime(start.getTime() + 3600 * 1000 * 24 * 3600);
            start.setHours(0, 0, 0, 0); // 设置为00:00:00
            end.setHours(23, 59, 59, 999); // 设置为23:59:59
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      tipIndex: '',
      myKey: false,
      categoryId: '',
      componentCode: '',
      componentSubcode: '',
      mType: '',
      options: [{
        label: '启用',
        value: 1
      }, {
        label: '停用',
        value: 0
      }],
      type: '',
      id: '',
      dialogVisible: false,
      activityJumpUrl: '',
      popTitle: '',
      timeArray: '',
      moduleId: '',
      ruleForm: {
        cornerMark: 0,
        cornerMarkPic: '',
        activityId: '',
        activityTypeName: '',
        activityName: '',
        bannerPic: '',
        bannerName: '',
        sort: '',
        status: null,
        openUrl: '',
        jumpType: 0,
        activityType: '',
        backgroundColorType: '',
        startColor: '',
        endColor: '',
        backgroundColor: ''
      },
      rules: {
        backgroundColorType: [{
          required: false
        }],
        startColor: [{
          required: false
        }],
        endColor: [{
          required: false
        }],
        backgroundColor: [{
          required: false
        }],
        jumpType: [{
          required: false,
          message: '请选择活动跳转类型',
          trigger: 'change'
        }],
        openUrl: [{
          required: false,
          message: '请输入跳转url',
          trigger: 'blur'
        }],
        bannerName: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        status: [{
          required: true,
          message: '请选择状态',
          trigger: 'change'
        }],
        sort: [{
          required: true,
          message: '请输入排序数字',
          trigger: 'blur'
        }],
        bannerPic: [{
          required: true,
          message: '请上传图片',
          trigger: 'change'
        }]
      }
    };
  },
  watch: {
    timeArray: function timeArray(val) {
      if (val === null) {
        var end = new Date();
        var start = new Date();
        end.setTime(start.getTime() + 3600 * 1000 * 24 * 3600);
        start.setHours(0, 0, 0, 0); // 设置为00:00:00
        end.setHours(23, 59, 59, 999); // 设置为23:59:59
        this.timeArray = [this.formatDate(start), this.formatDate(end)];
      }
    }
  },
  methods: {
    onSelectEvents: function onSelectEvents(data) {
      console.log(data);
      console.log(this.ruleForm, '-----------------------------------------');
      this.ruleForm.activityName = data.name || data.activityName || data.title;
      this.ruleForm.activityTypeName = data.Display_name;
      this.ruleForm.activityId = data.id || data.pageId;
      this.ruleForm.activityType = data.Display_type;
      this.activityJumpUrl = data.openUrl;
      console.log(this.ruleForm);
    },
    goAct: function goAct() {
      this.$refs.activitySelectionPopup.open();
    },
    handleAvatarSuccess: function handleAvatarSuccess() {},
    // 主图
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              console.log(pictureUrl, '-------------');
              this.ruleForm.bannerPic = pictureUrl;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    handleFileUpload1: function () {
      var _handleFileUpload2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(_ref2) {
        var file, pictureUrl, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              file = _ref2.file;
              _context2.p = 1;
              _context2.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context2.v;
              this.ruleForm.cornerMarkPic = pictureUrl;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.log('error ->', _t2);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function handleFileUpload1(_x2) {
        return _handleFileUpload2.apply(this, arguments);
      }
      return handleFileUpload1;
    }(),
    formatDate: function formatDate(d) {
      var date = new Date(d);
      var YY = date.getFullYear() + '-';
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + ' ' + hh + mm + ss;
    },
    open: function open(data) {
      console.log(data);
      this.popTitle = data.name;
      this.type = data.type;
      this.moduleId = data.moduleId;
      this.mType = data.mType || '';
      this.componentCode = data.componentCode;
      this.componentSubcode = data.componentSubcode || '';
      this.myKey = data.myKey || false;
      if (data.componentCode === 'bottomShopList') {
        this.categoryId = data.bannerId;
      }
      if (data.componentCode === 'verticalBannerWithPuzzle' && data.componentSubcode === 'v_ba_p_3') {
        this.tipIndex = data.index;
      }
      if (data.componentCode === 'diamond' && data.componentSubcode === 's_a_c') {
        this.categoryId = data.categoryId;
      }
      this.dialogVisible = true;
      if (this.type === 'add') {
        this.ruleForm = (0, _objectSpread2.default)({}, this.$options.data().ruleForm);
        // console.log(this.ruleForm, this.$options.data().ruleForm)
        var end = new Date();
        var start = new Date();
        end.setTime(start.getTime() + 3600 * 1000 * 24 * 3600);
        start.setHours(0, 0, 0, 0); // 设置为00:00:00
        end.setHours(23, 59, 59, 999); // 设置为23:59:59
        this.timeArray = [this.formatDate(start), this.formatDate(end)];
      } else {
        if (data.bannerId) {
          this.findBannerDetail(data.bannerId);
        }
      }
    },
    findBannerDetail: function findBannerDetail(val) {
      var _this = this;
      (0, _customPage.bannerDetail)({
        bannerId: val,
        type: this.componentCode === 'bottomShopList' ? 1 : ''
      }).then(function (res) {
        console.log(res);
        if (_this.componentCode === 'bottomShopList' && res.data.shopListMarketing != null) {
          _this.ruleForm = (0, _objectSpread2.default)({}, res.data.shopListMarketing);
          if (_this.ruleForm.jumpType === 2) {
            _this.ruleForm.openUrl = '';
            _this.activityJumpUrl = res.data.shopListMarketing.openUrl;
          }
          if (res.data.shopListMarketing.startTime && res.data.shopListMarketing.endTime) {
            _this.timeArray = [res.data.shopListMarketing.startTime, res.data.shopListMarketing.endTime];
          }
        } else {
          _this.ruleForm = (0, _objectSpread2.default)({}, res.data);
          if (_this.ruleForm.jumpType === 2) {
            _this.ruleForm.openUrl = '';
            _this.activityJumpUrl = res.data.openUrl;
          }
          if (res.data.startTime && res.data.endTime) {
            _this.timeArray = [res.data.startTime, res.data.endTime];
          }
        }
        console.log(_this.ruleForm);
      });
    },
    onClose: function onClose() {
      //   this.$refs['ruleForm9'].resetFields()
      this.resetForm('ruleForm9');
      this.activityJumpUrl = '';
      this.dialogVisible = false;
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          //   if (this.ruleForm.jumpType === 2 && !this.ruleForm.activityId) {
          //     this.$message.error('请选择活动')
          //     return
          //   }
          //   console.log(this.ruleForm, this.timeArray, this.moduleId)
          var params = (0, _objectSpread2.default)({}, _this2.ruleForm);
          params.startTime = _this2.timeArray[0];
          params.endTime = _this2.timeArray[1];
          if (_this2.ruleForm.jumpType === 2) {
            params.openUrl = _this2.activityJumpUrl;
          }
          if (_this2.mType) {
            params['bannerType'] = _this2.mType;
          }
          if (_this2.componentCode === 'diamond' && _this2.componentSubcode === 's_a_c') {
            params['categoryId'] = _this2.categoryId;
          }
          var obj = {};
          if (_this2.componentCode === 'bottomShopList') {
            params['categoryId'] = _this2.categoryId;
            obj = {
              moduleId: _this2.moduleId,
              shopListMarketing: params
            };
          } else {
            obj = {
              moduleId: _this2.moduleId,
              banner: params
            };
          }
          //   console.log(params)
          (0, _customPage.saveOrUpdateBanner)(obj).then(function (res) {
            if (res.data) {
              _this2.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });
              _this2.onClose();
              _this2.$emit('refresh');
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};